<template>
  <div class="cat-tipo-documento">
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de documento</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los tipos de documentos</option>
        <option v-for="TipoDeDocumento in TiposDeDocumentos" :key="TipoDeDocumento.TipoDocumentoId" :value="TipoDeDocumento.TipoDocumentoId">{{TipoDeDocumento.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import { mapActions } from 'vuex'

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        TiposDeDocumentos: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String 
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_PJ_Catalogo_Establecer004TipoDocumento", parametros);
    },
    methods: {
      cargaCatalogoDeTiposDeDocumentos() {        
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba      

        axios.post(api.conexion + api.PJ.catalogos.C004TipoDocumento, this.parametros)      
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
                this.TiposDeDocumentos = respuesta.data.TiposDeDocumento;
                if(this.parametros.elementosAConservar != undefined && this.parametros.elementosAConservar != null  && this.parametros.elementosAConservar.length > 0){
                  this.TiposDeDocumentos = this.TiposDeDocumentos.filter(element => {                  
                    if(this.parametros.elementosAConservar.includes(element.TipoDocumentoId))
                      return element;
                  });
                }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_PJ_Catalogo_Establecer004TipoDocumento", parametros);
        this.$emit("valorParaElPadre", evento);
        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }
    },
    created() {
      this.cargaCatalogoDeTiposDeDocumentos();
    }
  }
</script>

<style>
.cat-tipo-documento .form-control {
  background-color: white !important;
        color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/004TipoDocumento.vue